<mat-form-field appearance="outline" style="width: 100%;" [class.ss-focused]="focused">
  <mat-label>
    @if (icon) {
      <mat-icon>{{icon}}</mat-icon>
    }
    {{label}}
  </mat-label>
  <mat-chip-grid #chipGrid (click)="focusInput()">
    <input matInput
           #searchInput
           #trigger="matAutocompleteTrigger"
           [formControl]="searchCtrl"
           [matAutocomplete]="auto"
           [matChipInputFor]="chipGrid"
           (input)="filter(); trigger.openPanel()"
           (focus)="onFocus()"
           (blur)="clearSearch()">
    @for (val of selected; track val) {
      <mat-chip-row (removed)="remove(val)">
        {{getDescription(val)}}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
    }
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" [autoActiveFirstOption]="true" (optionSelected)="select($event)">
    @for (opt of filteredOptions; track opt.value) {
      <mat-option [value]="opt.value">
        @if (multiple) {
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; margin-right: 8px; vertical-align: middle;">
            {{isSelected(opt.value) ? 'check_box' : 'check_box_outline_blank'}}
          </mat-icon>
        }
        {{opt.description}}
      </mat-option>
    }
  </mat-autocomplete>
  @if (hint) {
    <mat-hint>{{hint}}</mat-hint>
  }
</mat-form-field>
